import { css, jsx, Box as Box$1, useThemeUI, Grid as Grid$1, Container as Container$2, Flex as Flex$1 } from 'theme-ui';
import React, { forwardRef, useMemo, createElement, cloneElement, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import { props } from '@monobits/types';
import cls from 'classnames';
import { withHover, linkA11yProps, withPlaystate, useDebounceRect, _asArray, _set, shadowBorders } from '@monobits/core';
import { setVariantString, spreadVariant } from '@monobits/theme-core';
import _styled from '@emotion/styled/base';
import { transitions, cover, position } from 'polished';
import { getMotion } from '@monobits/motion';
import { useTimeline, willChangeEvents } from '@monobits/gsap';
import { useConditionalEffect, useUpdateEffect, useMediaQuery, useToggle } from '@react-hookz/web';
import { pick, omit, times } from 'lodash';
import { nanoid } from 'nanoid';
import { keyframes } from '@emotion/react';
import { Cross, Arrow } from '@monobits/svg';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var x$5 = {
  gap: 'var(--gap, 2.5)',
  stroke: 'var(--stroke, 2px)',
  speed: 'var(--speed, 0.45s)',
  ease: 'var(--ease, ease)',
  color: 'var(--color, currentColor)'
};

var linePosition = function linePosition(position) {
  if (position === void 0) {
    position = 'top';
  }

  var pos = position === 'top' ? -1 : 1;
  return {
    transform: "translateY(calc((" + x$5.stroke + " * " + x$5.gap + ") * " + pos + ")) rotate(var(--hack, 0.01deg))"
  };
};

var initial = {
  '& .bars::before': linePosition('top'),
  '& .bars::after': linePosition('bottom')
};
var reversed = {
  '&._hover .bars::before': linePosition('bottom'),
  '&._hover .bars::after': linePosition('top')
};
var cross = {
  '&._active .bars::before': {
    transform: 'translateY(0) rotate(-45deg) !important'
  },
  '&._active .bars::after': {
    transform: 'translateY(0) rotate(45deg) !important'
  }
};

var EmotionBurger = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1k9luib1"
} : {
  target: "e1k9luib1",
  label: "EmotionBurger"
})(css({
  position: 'relative',
  minHeight: "calc(((" + x$5.stroke + " * 2) * " + x$5.gap + ") * 4)",
  display: 'flex',
  alignItems: 'center',
  userSelect: 'none',
  '--hack': ['0.01deg', '0.1deg']
}), initial, reversed, cross, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var EmotionBars = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1k9luib0"
} : {
  target: "e1k9luib0",
  label: "EmotionBars"
})(css({
  width: '100%',
  height: x$5.stroke,
  position: 'relative',
  pointerEvents: 'none',
  '::before,::after': _extends({
    content: '""',
    position: 'absolute',
    display: 'flex',
    bg: x$5.color,
    size: '100%'
  }, transitions(['transform'], x$5.speed + " " + x$5.ease), {
    willChange: 'transform'
  })
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var _EmotionBars;

var _excluded$j = ["variant", "hover", "active", "sx", "className"];
var KEYS$c = {
  VARIANT: 'burger'
};
var Burger = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
      hover = _ref.hover,
      active = _ref.active,
      sx = _ref.sx,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$j);

  return jsx(EmotionBurger, _extends({
    ref: ref,
    sx: _extends({
      variant: setVariantString(KEYS$c.VARIANT, variant)
    }, sx),
    className: cls(className, hover, {
      _active: active
    }),
    "aria-label": "burger menu"
  }, props), _EmotionBars || (_EmotionBars = jsx(EmotionBars, {
    className: "bars"
  })));
});
Burger.propTypes = _extends({
  active: PropTypes.any
}, props.themeUi);
Burger.defaultProps = {
  as: 'button'
};
Burger.displayName = 'Burger';
var Burger$1 = withHover(Burger, {
  mouse: true
});
var x$4 = {
  opacity: 'var(--disabled-opacity, 0.25)',
  speed: 'var(--speed, 0.45s)',
  ease: 'var(--ease, ease)',
  text: "var(--text, #000000)",
  bg: "var(--bg, #FFBD2B)",
  hover: {
    text: "var(--text-hover, #000000)",
    bg: "var(--bg-hover, #FFBD2B)"
  }
};
var disabled = "\n  opacity: " + x$4.opacity + ";\n  cursor: not-allowed;\n  pointer-events: none;\n";

var EmotionButton = _styled("button", process.env.NODE_ENV === "production" ? {
  target: "e6j1wr30"
} : {
  target: "e6j1wr30",
  label: "EmotionButton"
})(css({
  textAlign: 'center',
  userSelect: 'none',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  zIndex: 'default',
  '::before': _extends({}, cover(), {
    content: '""',
    overflow: 'hidden',
    zIndex: 'below'
  }, transitions(['transform', 'background-color'], x$4.speed + " " + x$4.ease), {
    bg: x$4.bg
  }),
  color: x$4.text,
  '&._hover': {
    color: x$4.hover.text,
    '::before': {
      bg: x$4.hover.bg
    }
  }
}), function (props) {
  return props.disabled && disabled;
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi5zdHlsZWQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0I2QiIsImZpbGUiOiJCdXR0b24uc3R5bGVkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjb3ZlciwgdHJhbnNpdGlvbnMgfSBmcm9tICdwb2xpc2hlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ3RoZW1lLXVpJ1xuXG5jb25zdCB4ID0ge1xuICBvcGFjaXR5OiAndmFyKC0tZGlzYWJsZWQtb3BhY2l0eSwgMC4yNSknLFxuICBzcGVlZDogJ3ZhcigtLXNwZWVkLCAwLjQ1cyknLFxuICBlYXNlOiAndmFyKC0tZWFzZSwgZWFzZSknLFxuICB0ZXh0OiBgdmFyKC0tdGV4dCwgIzAwMDAwMClgLFxuICBiZzogYHZhcigtLWJnLCAjRkZCRDJCKWAsXG4gIGhvdmVyOiB7XG4gICAgdGV4dDogYHZhcigtLXRleHQtaG92ZXIsICMwMDAwMDApYCxcbiAgICBiZzogYHZhcigtLWJnLWhvdmVyLCAjRkZCRDJCKWAsXG4gIH0sXG59XG5cbmNvbnN0IGRpc2FibGVkID0gYFxuICBvcGFjaXR5OiAke3gub3BhY2l0eX07XG4gIGN1cnNvcjogbm90LWFsbG93ZWQ7XG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xuYFxuXG5leHBvcnQgY29uc3QgRW1vdGlvbkJ1dHRvbiA9IHN0eWxlZC5idXR0b24oXG4gIGNzcyh7XG4gICAgdGV4dEFsaWduOiAnY2VudGVyJyxcbiAgICB1c2VyU2VsZWN0OiAnbm9uZScsXG5cbiAgICBkaXNwbGF5OiAnaW5saW5lLWZsZXgnLFxuICAgIGp1c3RpZnlDb250ZW50OiAnY2VudGVyJyxcbiAgICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcblxuICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgIHpJbmRleDogJ2RlZmF1bHQnLFxuXG4gICAgJzo6YmVmb3JlJzoge1xuICAgICAgLi4uY292ZXIoKSxcbiAgICAgIGNvbnRlbnQ6ICdcIlwiJyxcbiAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgIHpJbmRleDogJ2JlbG93JyxcbiAgICAgIC4uLnRyYW5zaXRpb25zKFsndHJhbnNmb3JtJywgJ2JhY2tncm91bmQtY29sb3InXSwgYCR7eC5zcGVlZH0gJHt4LmVhc2V9YCksXG5cbiAgICAgIGJnOiB4LmJnLFxuICAgIH0sXG5cbiAgICBjb2xvcjogeC50ZXh0LFxuICAgICcmLl9ob3Zlcic6IHtcbiAgICAgIGNvbG9yOiB4LmhvdmVyLnRleHQsXG4gICAgICAnOjpiZWZvcmUnOiB7XG4gICAgICAgIGJnOiB4LmhvdmVyLmJnLFxuICAgICAgfSxcbiAgICB9LFxuICB9KSxcbiAgKHByb3BzKSA9PiBwcm9wcy5kaXNhYmxlZCAmJiBkaXNhYmxlZFxuKVxuIl19 */");

var _excluded$i = ["sx", "variant", "size", "hover", "className"];
var KEYS$b = {
  STYLES: 'button.styles',
  VARIANT: 'button.variants',
  SIZE: 'button.sizes'
};
var Button$1 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _sx = _ref.sx,
      variant = _ref.variant,
      size = _ref.size,
      hover = _ref.hover,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$i);

  return jsx(EmotionButton, _extends({
    ref: ref,
    sx: function sx(theme) {
      return _extends({}, spreadVariant(theme, KEYS$b.STYLES, {
        styles: true
      }), spreadVariant(theme, KEYS$b.VARIANT, {
        value: variant
      }), spreadVariant(theme, KEYS$b.SIZE, {
        value: size
      }), _sx);
    },
    className: cls(className, hover)
  }, linkA11yProps(props, true)));
});
Button$1.propTypes = _extends({
  children: props.children,
  disabled: PropTypes.bool,
  size: props.variant
}, props.themeUi);
Button$1.defaultProps = {
  as: 'button',
  disabled: false
};
var Button$2 = withHover(Button$1);

var EmotionCollapsible = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "etpt12e0"
} : {
  target: "etpt12e0",
  label: "EmotionCollapsible"
})(function (_ref) {
  var expanded = _ref.expanded;
  return css({
    width: '100%',
    height: !expanded && 0,
    overflow: 'hidden'
  });
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbGxhcHNpYmxlLnN0eWxlZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHa0MiLCJmaWxlIjoiQ29sbGFwc2libGUuc3R5bGVkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MsIEJveCB9IGZyb20gJ3RoZW1lLXVpJ1xuXG5leHBvcnQgY29uc3QgRW1vdGlvbkNvbGxhcHNpYmxlID0gc3R5bGVkKEJveCkoKHsgZXhwYW5kZWQgfSkgPT5cbiAgY3NzKHtcbiAgICB3aWR0aDogJzEwMCUnLFxuICAgIGhlaWdodDogIWV4cGFuZGVkICYmIDAsXG4gICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICB9KVxuKVxuIl19 */");

var _excluded$h = ["children", "onTrigger", "expanded", "variant"],
    _excluded2$2 = ["duration"];

var Collapsible = function Collapsible(_ref) {
  var _getMotion;

  var children = _ref.children,
      onTrigger = _ref.onTrigger,
      expanded = _ref.expanded,
      variant = _ref.variant,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$h);

  var context = useThemeUI(null);
  var options = (_getMotion = getMotion(context, ['collapsible', variant])) == null ? void 0 : _getMotion.transition;

  var _useTimeline = useTimeline(function (_ref2) {
    var gsap = _ref2.gsap,
        node = _ref2.node;

    var duration = options.duration,
        props = _objectWithoutPropertiesLoose(options, _excluded2$2);

    return gsap.timeline(_extends({
      paused: true,
      defaults: _extends({}, props)
    }, willChangeEvents(node, 'height'))).to(node, {
      height: 'auto',
      duration: duration
    });
  }),
      timeline = _useTimeline[0],
      element = _useTimeline[1];

  useConditionalEffect(function () {
    var reversed = expanded ? !onTrigger : onTrigger;
    if (!reversed) timeline.play();
    if (reversed) timeline.reverse();
  }, [onTrigger], [timeline], undefined, useUpdateEffect);
  return /*#__PURE__*/React.createElement(EmotionCollapsible, _extends({
    ref: element.ref
  }, props, {
    expanded: expanded
  }), children && /*#__PURE__*/React.createElement(Box$1, {
    as: "article",
    sx: {
      variant: variant + ".content"
    }
  }, children));
};

Collapsible.defaultProps = {
  as: 'section',
  variant: 'collapsible',
  expanded: false
};
var _excluded$g = ["context", "whitelist", "inclusive", "variant", "sx", "className"];
var KEYS$a = {
  VARIANT: 'colorswitch.variants',
  STYLES: 'colorswitch.styles'
};
var ColorSwitch = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _extends2;

  var context = _ref.context,
      whitelist = _ref.whitelist,
      inclusive = _ref.inclusive,
      variant = _ref.variant,
      sx = _ref.sx,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  var id = useMemo(function () {
    return nanoid();
  }, []);
  var target = context.target,
      setTarget = context.setTarget,
      modes = context.modes;
  var selection = whitelist ? pick(modes, [].concat(whitelist)) : modes;
  var switchers = Object.entries(selection).map(function (_ref2) {
    var key = _ref2[0],
        value = _ref2[1];
    return /*#__PURE__*/React.createElement(Box$1, _extends({
      key: id + key,
      sx: {
        '--color': value.text,
        '--bg': value.background,
        color: 'var(--color)',
        bg: 'var(--bg)',
        variant: setVariantString(KEYS$a.VARIANT, variant)
      },
      "data-mode": key,
      onClick: function onClick() {
        return setTarget(key);
      },
      className: cls(className, {
        selected: target === key
      }),
      "aria-label": key + " theme switcher"
    }, props), /*#__PURE__*/React.createElement(Box$1, {
      as: "span",
      className: "name _noselect",
      sx: {
        textTransform: 'capitalize'
      }
    }, key));
  });
  return /*#__PURE__*/React.createElement(Grid$1, {
    ref: ref,
    sx: _extends((_extends2 = {
      variant: KEYS$a.STYLES
    }, _extends2["[data-mode=\"" + (!inclusive ? target : 'x') + "\"]"] = {
      display: 'none'
    }, _extends2), sx)
  }, switchers);
});
ColorSwitch.defaultProps = {
  as: 'button',
  inclusive: false
};
var _excluded$f = ["children", "variant", "sx"];
var KEYS$9 = {
  VARIANT: 'layout.container'
};
var Container$1 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      variant = _ref.variant,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$f);

  return /*#__PURE__*/React.createElement(Container$2, _extends({
    ref: ref,
    sx: _extends({
      display: 'block',
      variant: setVariantString(KEYS$9.VARIANT, variant)
    }, sx)
  }, props), children);
});
var _excluded$e = ["label", "symbol"];
var Emoji = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
      symbol = _ref.symbol,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$e);

  return /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref,
    "aria-hidden": !label,
    "aria-label": label,
    role: "img"
  }, props), symbol);
});
Emoji.defaultProps = {
  as: 'span',
  symbol: '🦖'
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var EmotionText = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1ts75ww0"
} : {
  target: "e1ts75ww0",
  label: "EmotionText"
})(process.env.NODE_ENV === "production" ? {
  name: "ezcgz1",
  styles: "&[data-cropped=false]::before,&[data-cropped=false]::after{display:none!important;}&[data-cropped=\"bottom\"]::before{display:none!important;}&[data-cropped=\"top\"]::after{display:none!important;}"
} : {
  name: "ezcgz1",
  styles: "&[data-cropped=false]::before,&[data-cropped=false]::after{display:none!important;}&[data-cropped=\"bottom\"]::before{display:none!important;}&[data-cropped=\"top\"]::after{display:none!important;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRleHQuc3R5bGVkLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUUyQiIsImZpbGUiOiJUZXh0LnN0eWxlZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5leHBvcnQgY29uc3QgRW1vdGlvblRleHQgPSBzdHlsZWQuc3Bhbih7XG4gICcmW2RhdGEtY3JvcHBlZD1mYWxzZV06OmJlZm9yZSwmW2RhdGEtY3JvcHBlZD1mYWxzZV06OmFmdGVyJzoge1xuICAgIGRpc3BsYXk6ICdub25lIWltcG9ydGFudCcsXG4gIH0sXG4gICcmW2RhdGEtY3JvcHBlZD1cImJvdHRvbVwiXTo6YmVmb3JlJzoge1xuICAgIGRpc3BsYXk6ICdub25lIWltcG9ydGFudCcsXG4gIH0sXG4gICcmW2RhdGEtY3JvcHBlZD1cInRvcFwiXTo6YWZ0ZXInOiB7XG4gICAgZGlzcGxheTogJ25vbmUhaW1wb3J0YW50JyxcbiAgfSxcbn0pXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var _excluded$d = ["children", "variant", "sx", "rte", "className", "cropped"];
var KEYS$8 = {
  VARIANT: 'text'
};
var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      variant = _ref.variant,
      sx = _ref.sx,
      rte = _ref.rte,
      className = _ref.className,
      cropped = _ref.cropped,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  return jsx(EmotionText, _extends({
    ref: ref,
    sx: _extends({
      variant: setVariantString(KEYS$8.VARIANT, variant)
    }, sx),
    className: cls(className, {
      '-rte': rte
    }),
    "data-cropped": cropped
  }, props), children);
});
Text.propTypes = _extends({
  children: PropTypes.any.isRequired,
  rte: PropTypes.bool
}, props.themeUi);
Text.defaultProps = {
  as: 'p',
  cropped: true,
  rte: true
};
var Heading = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    ref: ref
  }, props));
});
Heading.defaultProps = {
  as: 'h2',
  variant: 'heading',
  rte: false
};
var _excluded$c = ["icon", "variant", "stroke", "color", "sx"],
    _excluded2$1 = ["sx"];
var KEYS$7 = {
  VARIANT: 'icon.variants'
};
var CSS_VARIABLES = {
  scale: '--stroke-relative',
  noscale: '--stroke-absolute',
  __default: '--stroke-relative'
};
var Icon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _extends2;

  var Component = _ref.icon,
      variant = _ref.variant,
      stroke = _ref.stroke,
      color = _ref.color,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  return jsx(Component, _extends({
    ref: ref,
    sx: _extends((_extends2 = {
      '--a': (sx == null ? void 0 : sx.color) || color,
      variant: setVariantString(KEYS$7.VARIANT, variant)
    }, _extends2[CSS_VARIABLES[variant]] = stroke, _extends2), omit(sx, ['color']))
  }, props));
});
var Themed = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _sx = _ref2.sx,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);

  return jsx(Icon, _extends({
    ref: ref,
    sx: function sx(theme) {
      var _theme$colors;

      return _extends({}, (_theme$colors = theme.colors) == null ? void 0 : _theme$colors.svg, _sx);
    }
  }, props));
});
Icon.propTypes = {
  icon: props.svg,
  stroke: props.sxProperty,
  color: PropTypes.string,
  variant: PropTypes.oneOf(Object.keys(CSS_VARIABLES)),
  sx: props.sx
};
Icon.defaultProps = {
  color: 'currentColor'
};
Icon.Themed = Themed;
Icon.Themed.displayName = 'Icon.Themed';
var _excluded$b = ["active", "variant", "sx", "className"];
var KEYS$6 = {
  VARIANT: 'cssmotion'
};

var IconButton$1 = function IconButton(_ref) {
  var active = _ref.active,
      variant = _ref.variant,
      sx = _ref.sx,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$b);

  return /*#__PURE__*/React.createElement(Box$1, _extends({
    sx: _extends({
      display: 'inline-flex',
      variant: setVariantString(KEYS$6.VARIANT, variant)
    }, sx),
    className: cls(className, {
      _active: active
    })
  }, props));
};

IconButton$1.defaultProps = {
  as: 'button',
  variant: 'base',
  active: false
};

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;

var x$3 = {
  speed: 'var(--speed, 8s)',
  bg: 'var(--bg, none)'
};
var Animation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  from {\n    transform: translate3d(-0%, 0, 0);\n  }\n  to {\n    transform: translate3d(-50%, 0, 0);\n  }\n"])));

var EmotionMarquee = /*#__PURE__*/_styled(Flex$1, process.env.NODE_ENV === "production" ? {
  target: "eek61811"
} : {
  target: "eek61811",
  label: "EmotionMarquee"
})(css({
  width: '100%',
  alignItems: 'center',
  position: 'relative',
  zIndex: 'default',
  '>div::before': {
    bg: x$3.bg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1hcnF1ZWUuc3R5bGVkLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1COEIiLCJmaWxlIjoiTWFycXVlZS5zdHlsZWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0J1xuaW1wb3J0IHsgcG9zaXRpb24gfSBmcm9tICdwb2xpc2hlZCdcbmltcG9ydCB7IGNzcywgRmxleCB9IGZyb20gJ3RoZW1lLXVpJ1xuXG5leHBvcnQgY29uc3QgeCA9IHtcbiAgc3BlZWQ6ICd2YXIoLS1zcGVlZCwgOHMpJyxcbiAgYmc6ICd2YXIoLS1iZywgbm9uZSknLFxufVxuXG5jb25zdCBBbmltYXRpb24gPSBrZXlmcmFtZXNgXG4gIGZyb20ge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlM2QoLTAlLCAwLCAwKTtcbiAgfVxuICB0byB7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUzZCgtNTAlLCAwLCAwKTtcbiAgfVxuYFxuXG5leHBvcnQgY29uc3QgRW1vdGlvbk1hcnF1ZWUgPSBzdHlsZWQoRmxleCkoXG4gIGNzcyh7XG4gICAgd2lkdGg6ICcxMDAlJyxcbiAgICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICB6SW5kZXg6ICdkZWZhdWx0JyxcblxuICAgICc+ZGl2OjpiZWZvcmUnOiB7IGJnOiB4LmJnIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBFbW90aW9uSW5zdGFuY2VzID0gc3R5bGVkLmRpdigoeyBsdHIgfSkgPT5cbiAgY3NzKHtcbiAgICB3aWR0aDogJ2F1dG8nLFxuICAgIGRpc3BsYXk6ICdpbmxpbmUtZmxleCcsXG5cbiAgICB1c2VyU2VsZWN0OiAnbm9uZScsXG4gICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG5cbiAgICBhbmltYXRpb246IGAke0FuaW1hdGlvbn0gJHt4LnNwZWVkfSBmb3J3YXJkcyBsaW5lYXIgaW5maW5pdGVgLFxuICAgIGFuaW1hdGlvbkRpcmVjdGlvbjogIWx0ciA/ICdyZXZlcnNlJyA6ICdub3JtYWwnLFxuXG4gICAgJyYuLXBhdXNlZCc6IHsgYW5pbWF0aW9uUGxheVN0YXRlOiAncGF1c2VkJyB9LFxuICAgICcmLi1pZGxlJzoge1xuICAgICAgY3Vyc29yOiAncHJvZ3Jlc3MnLFxuICAgICAgJyYuX2hvdmVyJzogeyBhbmltYXRpb25QbGF5U3RhdGU6ICdwYXVzZWQnIH0sXG4gICAgfSxcblxuICAgICc6OmJlZm9yZSc6IHtcbiAgICAgIGNvbnRlbnQ6ICdcIlwiJyxcbiAgICAgIGRpc3BsYXk6ICdibG9jaycsXG4gICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICAgIC4uLnBvc2l0aW9uKDAsICctNWVtJywgMCwgJy01ZW0nKSxcbiAgICAgIHpJbmRleDogJ2JlbG93JyxcbiAgICB9LFxuICB9KVxuKVxuIl19 */");

var EmotionInstances = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eek61810"
} : {
  target: "eek61810",
  label: "EmotionInstances"
})(function (_ref) {
  var ltr = _ref.ltr;
  return css({
    width: 'auto',
    display: 'inline-flex',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    animation: Animation + " " + x$3.speed + " forwards linear infinite",
    animationDirection: !ltr ? 'reverse' : 'normal',
    '&.-paused': {
      animationPlayState: 'paused'
    },
    '&.-idle': {
      cursor: 'progress',
      '&._hover': {
        animationPlayState: 'paused'
      }
    },
    '::before': _extends({
      content: '""',
      display: 'block',
      position: 'absolute'
    }, position(0, '-5em', 0, '-5em'), {
      zIndex: 'below'
    })
  });
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1hcnF1ZWUuc3R5bGVkLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQThCZ0MiLCJmaWxlIjoiTWFycXVlZS5zdHlsZWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0J1xuaW1wb3J0IHsgcG9zaXRpb24gfSBmcm9tICdwb2xpc2hlZCdcbmltcG9ydCB7IGNzcywgRmxleCB9IGZyb20gJ3RoZW1lLXVpJ1xuXG5leHBvcnQgY29uc3QgeCA9IHtcbiAgc3BlZWQ6ICd2YXIoLS1zcGVlZCwgOHMpJyxcbiAgYmc6ICd2YXIoLS1iZywgbm9uZSknLFxufVxuXG5jb25zdCBBbmltYXRpb24gPSBrZXlmcmFtZXNgXG4gIGZyb20ge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlM2QoLTAlLCAwLCAwKTtcbiAgfVxuICB0byB7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUzZCgtNTAlLCAwLCAwKTtcbiAgfVxuYFxuXG5leHBvcnQgY29uc3QgRW1vdGlvbk1hcnF1ZWUgPSBzdHlsZWQoRmxleCkoXG4gIGNzcyh7XG4gICAgd2lkdGg6ICcxMDAlJyxcbiAgICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICB6SW5kZXg6ICdkZWZhdWx0JyxcblxuICAgICc+ZGl2OjpiZWZvcmUnOiB7IGJnOiB4LmJnIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBFbW90aW9uSW5zdGFuY2VzID0gc3R5bGVkLmRpdigoeyBsdHIgfSkgPT5cbiAgY3NzKHtcbiAgICB3aWR0aDogJ2F1dG8nLFxuICAgIGRpc3BsYXk6ICdpbmxpbmUtZmxleCcsXG5cbiAgICB1c2VyU2VsZWN0OiAnbm9uZScsXG4gICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG5cbiAgICBhbmltYXRpb246IGAke0FuaW1hdGlvbn0gJHt4LnNwZWVkfSBmb3J3YXJkcyBsaW5lYXIgaW5maW5pdGVgLFxuICAgIGFuaW1hdGlvbkRpcmVjdGlvbjogIWx0ciA/ICdyZXZlcnNlJyA6ICdub3JtYWwnLFxuXG4gICAgJyYuLXBhdXNlZCc6IHsgYW5pbWF0aW9uUGxheVN0YXRlOiAncGF1c2VkJyB9LFxuICAgICcmLi1pZGxlJzoge1xuICAgICAgY3Vyc29yOiAncHJvZ3Jlc3MnLFxuICAgICAgJyYuX2hvdmVyJzogeyBhbmltYXRpb25QbGF5U3RhdGU6ICdwYXVzZWQnIH0sXG4gICAgfSxcblxuICAgICc6OmJlZm9yZSc6IHtcbiAgICAgIGNvbnRlbnQ6ICdcIlwiJyxcbiAgICAgIGRpc3BsYXk6ICdibG9jaycsXG4gICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICAgIC4uLnBvc2l0aW9uKDAsICctNWVtJywgMCwgJy01ZW0nKSxcbiAgICAgIHpJbmRleDogJ2JlbG93JyxcbiAgICB9LFxuICB9KVxuKVxuIl19 */");

var _excluded$a = ["children", "id", "multiplier", "playRef", "playClasses", "hover", "className"];

var Instances = function Instances(_ref) {
  var children = _ref.children,
      id = _ref.id,
      multiplier = _ref.multiplier,
      playRef = _ref.playRef,
      playClasses = _ref.playClasses,
      hover = _ref.hover,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  return /*#__PURE__*/createElement(EmotionInstances, _extends({
    ref: playRef,
    className: cls(className, hover, playClasses)
  }, props), times(2 * multiplier, function (i) {
    return /*#__PURE__*/cloneElement(children, {
      key: id + i,
      as: 'span',
      'aria-hidden': i > 0 || null
    });
  }));
};

var Instances$1 = withPlaystate(withHover(Instances, {
  mouse: true
}));
var _excluded$9 = ["children", "variant", "sx"],
    _excluded2 = ["speed", "paused", "idle", "ltr", "multiplier"];
var KEYS$5 = {
  VARIANT: 'marquee.variants'
};

var Marquee = function Marquee(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  var speed = props.speed,
      paused = props.paused,
      idle = props.idle,
      ltr = props.ltr,
      multiplier = props.multiplier,
      rest = _objectWithoutPropertiesLoose(props, _excluded2);

  var id = useMemo(function () {
    return nanoid();
  }, []);

  var _speed = speed && {
    '--speed': speed
  };

  return /*#__PURE__*/React.createElement(EmotionMarquee, _extends({
    sx: _extends({
      variant: setVariantString(KEYS$5.VARIANT, variant)
    }, _speed, sx)
  }, rest), /*#__PURE__*/React.createElement(Instances$1, {
    id: id,
    paused: paused,
    idle: idle,
    ltr: ltr,
    multiplier: multiplier
  }, children));
};

Marquee.defaultProps = {
  as: 'h2',
  ltr: true,
  idle: false,
  paused: false,
  speed: null,
  multiplier: 2
};
Marquee.Legacy = Marquee;
var x$2 = {
  sup: 'var(--sup-scale, 0.65)',
  from: 'var(--from, 0.1deg)',
  to: 'var(--to, -12deg)',
  speed: 'var(--speed, 0.45s)',
  ease: 'var(--ease, ease)'
};

var EmotionSkewLink = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "e1gbwhbb0"
} : {
  target: "e1gbwhbb0",
  label: "EmotionSkewLink"
})(css({
  width: 'fit-content',
  whiteSpace: 'nowrap',
  position: 'relative',
  userSelect: 'none',
  transform: "skew(" + x$2.from + ")",
  '&._hover': {
    transform: "skew(" + x$2.to + ")"
  },
  transition: "transform " + x$2.speed + " " + x$2.ease,
  sup: {
    position: 'absolute',
    top: 0,
    display: 'inline-block',
    transform: "scale(" + x$2.sup + ")",
    transformOrigin: 'top left'
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNrZXdMaW5rLnN0eWxlZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXK0IiLCJmaWxlIjoiU2tld0xpbmsuc3R5bGVkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MsIEJveCB9IGZyb20gJ3RoZW1lLXVpJ1xuXG5jb25zdCB4ID0ge1xuICBzdXA6ICd2YXIoLS1zdXAtc2NhbGUsIDAuNjUpJyxcbiAgZnJvbTogJ3ZhcigtLWZyb20sIDAuMWRlZyknLFxuICB0bzogJ3ZhcigtLXRvLCAtMTJkZWcpJyxcbiAgc3BlZWQ6ICd2YXIoLS1zcGVlZCwgMC40NXMpJyxcbiAgZWFzZTogJ3ZhcigtLWVhc2UsIGVhc2UpJyxcbn1cblxuZXhwb3J0IGNvbnN0IEVtb3Rpb25Ta2V3TGluayA9IHN0eWxlZChCb3gpKFxuICBjc3Moe1xuICAgIHdpZHRoOiAnZml0LWNvbnRlbnQnLFxuICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuXG4gICAgdXNlclNlbGVjdDogJ25vbmUnLFxuXG4gICAgdHJhbnNmb3JtOiBgc2tldygke3guZnJvbX0pYCxcbiAgICAnJi5faG92ZXInOiB7XG4gICAgICB0cmFuc2Zvcm06IGBza2V3KCR7eC50b30pYCxcbiAgICB9LFxuXG4gICAgdHJhbnNpdGlvbjogYHRyYW5zZm9ybSAke3guc3BlZWR9ICR7eC5lYXNlfWAsXG5cbiAgICBzdXA6IHtcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgdG9wOiAwLFxuXG4gICAgICBkaXNwbGF5OiAnaW5saW5lLWJsb2NrJyxcbiAgICAgIHRyYW5zZm9ybTogYHNjYWxlKCR7eC5zdXB9KWAsXG4gICAgICB0cmFuc2Zvcm1PcmlnaW46ICd0b3AgbGVmdCcsXG4gICAgfSxcbiAgfSlcbilcbiJdfQ== */");

var _excluded$8 = ["children", "num", "hover", "sx", "variant", "locale", "className"];
var KEYS$4 = {
  VARIANT: 'link.menu'
};
var SkewLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      num = _ref.num,
      hover = _ref.hover,
      sx = _ref.sx,
      variant = _ref.variant,
      locale = _ref.locale,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  return /*#__PURE__*/React.createElement(EmotionSkewLink, _extends({
    ref: ref,
    className: cls(className, hover),
    sx: _extends({
      variant: setVariantString(KEYS$4.VARIANT, variant)
    }, sx)
  }, props), children, num > 0 && /*#__PURE__*/React.createElement("sup", {
    "aria-label": locales(num)[locale]
  }, "(" + num + ")"));
});

var locales = function locales(num) {
  return {
    en: "contains " + num + " items",
    fr: "contiens " + num + " items"
  };
};

SkewLink.defaultProps = {
  as: 'h2',
  num: 0,
  locale: 'en'
};
var SkewLink$1 = withHover(SkewLink, {
  mouse: true
});

var Container = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "e1wyupvg1"
} : {
  target: "e1wyupvg1",
  label: "Container"
})(css({
  width: 'fit-content',
  display: 'flex'
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcm9sbGVyLnN0eWxlZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHeUIiLCJmaWxlIjoiU2Nyb2xsZXIuc3R5bGVkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MsIEJveCB9IGZyb20gJ3RoZW1lLXVpJ1xuXG5leHBvcnQgY29uc3QgQ29udGFpbmVyID0gc3R5bGVkKEJveCkoXG4gIGNzcyh7XG4gICAgd2lkdGg6ICdmaXQtY29udGVudCcsXG4gICAgZGlzcGxheTogJ2ZsZXgnLFxuICB9KVxuKVxuZXhwb3J0IGNvbnN0IENvbnRlbnQgPSBzdHlsZWQoQm94KShcbiAgY3NzKHtcbiAgICBkaXNwbGF5OiAnaW5saW5lLWZsZXgnLFxuICAgIHdpZHRoOiAnMTAwJScsXG4gICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgTXNPdmVyZmxvd1N0eWxlOiAnbm9uZScsXG4gICAgc2Nyb2xsYmFyV2lkdGg6ICdub25lJyxcbiAgICAnJjo6LXdlYmtpdC1zY3JvbGxiYXInOiB7IGRpc3BsYXk6ICdub25lJyB9LFxuICB9KVxuKVxuIl19 */");

var Content = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "e1wyupvg0"
} : {
  target: "e1wyupvg0",
  label: "Content"
})(css({
  display: 'inline-flex',
  width: '100%',
  whiteSpace: 'nowrap',
  MsOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcm9sbGVyLnN0eWxlZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTdUIiLCJmaWxlIjoiU2Nyb2xsZXIuc3R5bGVkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MsIEJveCB9IGZyb20gJ3RoZW1lLXVpJ1xuXG5leHBvcnQgY29uc3QgQ29udGFpbmVyID0gc3R5bGVkKEJveCkoXG4gIGNzcyh7XG4gICAgd2lkdGg6ICdmaXQtY29udGVudCcsXG4gICAgZGlzcGxheTogJ2ZsZXgnLFxuICB9KVxuKVxuZXhwb3J0IGNvbnN0IENvbnRlbnQgPSBzdHlsZWQoQm94KShcbiAgY3NzKHtcbiAgICBkaXNwbGF5OiAnaW5saW5lLWZsZXgnLFxuICAgIHdpZHRoOiAnMTAwJScsXG4gICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgTXNPdmVyZmxvd1N0eWxlOiAnbm9uZScsXG4gICAgc2Nyb2xsYmFyV2lkdGg6ICdub25lJyxcbiAgICAnJjo6LXdlYmtpdC1zY3JvbGxiYXInOiB7IGRpc3BsYXk6ICdub25lJyB9LFxuICB9KVxuKVxuIl19 */");

var _excluded$7 = ["children", "maxWidth", "scrollable", "sx"];
var Scroller = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      maxWidth = _ref.maxWidth,
      scrollable = _ref.scrollable,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: ref,
    sx: _extends({
      maxWidth: scrollable && maxWidth
    }, sx)
  }, props), /*#__PURE__*/React.createElement(Content, {
    sx: {
      overflow: scrollable && 'scroll'
    }
  }, children));
});
Scroller.defaultProps = {
  maxWidth: '100%',
  scrollable: true
};
/** We reexport these components because they break Storybook MDX */

var Box = function Box(props) {
  return /*#__PURE__*/React.createElement(Box$1, props);
};

var Flex = function Flex(props) {
  return /*#__PURE__*/React.createElement(Flex$1, props);
};

var Markup = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "efwv9cr0"
} : {
  target: "efwv9cr0",
  label: "Markup"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRoZW1lQ29tcG9uZW50cy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRc0IiLCJmaWxlIjoiVGhlbWVDb21wb25lbnRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBCb3ggYXMgQSwgRmxleCBhcyBCIH0gZnJvbSAndGhlbWUtdWknXG5cbi8qKiBXZSByZWV4cG9ydCB0aGVzZSBjb21wb25lbnRzIGJlY2F1c2UgdGhleSBicmVhayBTdG9yeWJvb2sgTURYICovXG5leHBvcnQgY29uc3QgQm94ID0gKHByb3BzKSA9PiA8QSB7Li4ucHJvcHN9IC8+XG5leHBvcnQgY29uc3QgRmxleCA9IChwcm9wcykgPT4gPEIgey4uLnByb3BzfSAvPlxuXG5leHBvcnQgY29uc3QgTWFya3VwID0gc3R5bGVkLmRpdigpXG4iXX0= */");

var _excluded$6 = ["children", "variant", "sx", "vh", "offset"];
var KEYS$3 = {
  VARIANT: 'layout.section'
};
var Section = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      variant = _ref.variant,
      sx = _ref.sx,
      vh = _ref.vh,
      offset = _ref.offset,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  return jsx(Markup, _extends({
    ref: ref,
    sx: _extends({
      position: 'relative',
      variant: setVariantString(KEYS$3.VARIANT, variant),
      '--height': vh,
      '--offset': offset
    }, sx)
  }, props), children);
});
Section.propTypes = _extends({
  children: PropTypes.any.isRequired,
  offset: props.sxProperty,
  vh: props.sxProperty
}, props.themeUi);
Section.defaultProps = {
  as: 'section'
};
var _excluded$5 = ["callbacks", "debounce"];
/**
 * Add's Viewport Height Custom Properties to the HTML root
 *
 * @param {Array} props.callbacks Element to watch for updates
 *
 * @example <Sizes callbacks={[location, loaded]} />
 */

var Sizes = function Sizes(_ref) {
  var _ref$callbacks = _ref.callbacks,
      callbacks = _ref$callbacks === void 0 ? [] : _ref$callbacks,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 300 : _ref$debounce,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  var set = useRef(false);

  var _useDebounceRect = useDebounceRect(debounce),
      ref = _useDebounceRect[0],
      _useDebounceRect$1$he = _useDebounceRect[1].height,
      height = _useDebounceRect$1$he === void 0 ? null : _useDebounceRect$1$he;

  var isMobile = useMediaQuery('(hover: none)', false);
  var watch = [].concat(_asArray(callbacks), [isMobile]); // Update on height change

  useConditionalEffect(function () {
    return _CSSVH(height, 'x');
  }, [].concat(watch, [height]), [height != null, !!isMobile]); // Update only once

  useConditionalEffect(function () {
    set.current = true;

    _CSSVH(height);
  }, [].concat(watch, [height]), [height != null, !set.current, !!isMobile]);
  return jsx("div", _extends({
    ref: ref,
    sx: styles
  }, props));
};

var _CSSVH = function _CSSVH(value, key) {
  return _set.cssvar("--vh" + (key ? '-' + key : ''), value * 0.01 + "px");
}; // prettier-ignore


var styles = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  pointerEvents: 'none',
  userSelect: 'none',
  zIndex: '-10'
};
Sizes.propTypes = process.env.NODE_ENV !== "production" ? {
  callbacks: PropTypes.any
} : {};
var x$1 = {
  stroke: 'var(--stroke)',
  offset: 'var(--offset, -30px)',
  fontSize: 'var(--font-size)',
  py: 'var(--py)',
  gap: 'var(--gap)'
};

var Row = /*#__PURE__*/_styled(Flex$1, process.env.NODE_ENV === "production" ? {
  target: "e137hhyr3"
} : {
  target: "e137hhyr3",
  label: "Row"
})(css(_extends({
  flexDirection: 'column'
}, shadowBorders({
  top: true,
  bottom: true,
  stroke: x$1.stroke
}), {
  '&.row + &.row': {
    '::before': {
      top: x$1.offset,
      bottom: 0
    }
  }
})), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYmxlUm93LnN0eWxlZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFhbUIiLCJmaWxlIjoiVGFibGVSb3cuc3R5bGVkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBzaGFkb3dCb3JkZXJzIH0gZnJvbSAnQG1vbm9iaXRzL2NvcmUnXG5pbXBvcnQgeyBjc3MsIEZsZXgsIEdyaWQgYXMgVGhlbWVHcmlkIH0gZnJvbSAndGhlbWUtdWknXG5pbXBvcnQgQmFzZUljb25CdXR0b24gZnJvbSAnLi4vSWNvbkJ1dHRvbidcblxuY29uc3QgeCA9IHtcbiAgc3Ryb2tlOiAndmFyKC0tc3Ryb2tlKScsXG4gIG9mZnNldDogJ3ZhcigtLW9mZnNldCwgLTMwcHgpJyxcbiAgZm9udFNpemU6ICd2YXIoLS1mb250LXNpemUpJyxcbiAgcHk6ICd2YXIoLS1weSknLFxuICBnYXA6ICd2YXIoLS1nYXApJyxcbn1cblxuZXhwb3J0IGNvbnN0IFJvdyA9IHN0eWxlZChGbGV4KShcbiAgY3NzKHtcbiAgICBmbGV4RGlyZWN0aW9uOiAnY29sdW1uJyxcblxuICAgIC4uLnNoYWRvd0JvcmRlcnMoeyB0b3A6IHRydWUsIGJvdHRvbTogdHJ1ZSwgc3Ryb2tlOiB4LnN0cm9rZSB9KSxcbiAgICAnJi5yb3cgKyAmLnJvdyc6IHtcbiAgICAgICc6OmJlZm9yZSc6IHsgdG9wOiB4Lm9mZnNldCwgYm90dG9tOiAwIH0sXG4gICAgfSxcbiAgfSlcbilcbmV4cG9ydCBjb25zdCBIZWFkID0gc3R5bGVkKEZsZXgpKFxuICBjc3Moe1xuICAgIHdpZHRoOiAnMTAwJScsXG4gICAgZm9udFNpemU6IHguZm9udFNpemUsXG4gICAgYWxpZ25JdGVtczogJ3N0cmV0Y2gnLFxuICB9KVxuKVxuZXhwb3J0IGNvbnN0IEdyaWQgPSBzdHlsZWQoVGhlbWVHcmlkKShcbiAgY3NzKHtcbiAgICBweTogeC5weSxcbiAgICB3aWR0aDogJzEwMCUnLFxuICAgIGdyaWRHYXA6IHguZ2FwLFxuICB9KVxuKVxuZXhwb3J0IGNvbnN0IEljb25CdXR0b24gPSBzdHlsZWQoQmFzZUljb25CdXR0b24pKFxuICBjc3Moe1xuICAgIG1sOiB4LmdhcCxcbiAgICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgfSlcbilcbiJdfQ== */");

var Head = /*#__PURE__*/_styled(Flex$1, process.env.NODE_ENV === "production" ? {
  target: "e137hhyr2"
} : {
  target: "e137hhyr2",
  label: "Head"
})(css({
  width: '100%',
  fontSize: x$1.fontSize,
  alignItems: 'stretch'
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYmxlUm93LnN0eWxlZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1Qm9CIiwiZmlsZSI6IlRhYmxlUm93LnN0eWxlZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgc2hhZG93Qm9yZGVycyB9IGZyb20gJ0Btb25vYml0cy9jb3JlJ1xuaW1wb3J0IHsgY3NzLCBGbGV4LCBHcmlkIGFzIFRoZW1lR3JpZCB9IGZyb20gJ3RoZW1lLXVpJ1xuaW1wb3J0IEJhc2VJY29uQnV0dG9uIGZyb20gJy4uL0ljb25CdXR0b24nXG5cbmNvbnN0IHggPSB7XG4gIHN0cm9rZTogJ3ZhcigtLXN0cm9rZSknLFxuICBvZmZzZXQ6ICd2YXIoLS1vZmZzZXQsIC0zMHB4KScsXG4gIGZvbnRTaXplOiAndmFyKC0tZm9udC1zaXplKScsXG4gIHB5OiAndmFyKC0tcHkpJyxcbiAgZ2FwOiAndmFyKC0tZ2FwKScsXG59XG5cbmV4cG9ydCBjb25zdCBSb3cgPSBzdHlsZWQoRmxleCkoXG4gIGNzcyh7XG4gICAgZmxleERpcmVjdGlvbjogJ2NvbHVtbicsXG5cbiAgICAuLi5zaGFkb3dCb3JkZXJzKHsgdG9wOiB0cnVlLCBib3R0b206IHRydWUsIHN0cm9rZTogeC5zdHJva2UgfSksXG4gICAgJyYucm93ICsgJi5yb3cnOiB7XG4gICAgICAnOjpiZWZvcmUnOiB7IHRvcDogeC5vZmZzZXQsIGJvdHRvbTogMCB9LFxuICAgIH0sXG4gIH0pXG4pXG5leHBvcnQgY29uc3QgSGVhZCA9IHN0eWxlZChGbGV4KShcbiAgY3NzKHtcbiAgICB3aWR0aDogJzEwMCUnLFxuICAgIGZvbnRTaXplOiB4LmZvbnRTaXplLFxuICAgIGFsaWduSXRlbXM6ICdzdHJldGNoJyxcbiAgfSlcbilcbmV4cG9ydCBjb25zdCBHcmlkID0gc3R5bGVkKFRoZW1lR3JpZCkoXG4gIGNzcyh7XG4gICAgcHk6IHgucHksXG4gICAgd2lkdGg6ICcxMDAlJyxcbiAgICBncmlkR2FwOiB4LmdhcCxcbiAgfSlcbilcbmV4cG9ydCBjb25zdCBJY29uQnV0dG9uID0gc3R5bGVkKEJhc2VJY29uQnV0dG9uKShcbiAgY3NzKHtcbiAgICBtbDogeC5nYXAsXG4gICAgYWxpZ25JdGVtczogJ2NlbnRlcicsXG4gIH0pXG4pXG4iXX0= */");

var Grid = /*#__PURE__*/_styled(Grid$1, process.env.NODE_ENV === "production" ? {
  target: "e137hhyr1"
} : {
  target: "e137hhyr1",
  label: "Grid"
})(css({
  py: x$1.py,
  width: '100%',
  gridGap: x$1.gap
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYmxlUm93LnN0eWxlZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4Qm9CIiwiZmlsZSI6IlRhYmxlUm93LnN0eWxlZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgc2hhZG93Qm9yZGVycyB9IGZyb20gJ0Btb25vYml0cy9jb3JlJ1xuaW1wb3J0IHsgY3NzLCBGbGV4LCBHcmlkIGFzIFRoZW1lR3JpZCB9IGZyb20gJ3RoZW1lLXVpJ1xuaW1wb3J0IEJhc2VJY29uQnV0dG9uIGZyb20gJy4uL0ljb25CdXR0b24nXG5cbmNvbnN0IHggPSB7XG4gIHN0cm9rZTogJ3ZhcigtLXN0cm9rZSknLFxuICBvZmZzZXQ6ICd2YXIoLS1vZmZzZXQsIC0zMHB4KScsXG4gIGZvbnRTaXplOiAndmFyKC0tZm9udC1zaXplKScsXG4gIHB5OiAndmFyKC0tcHkpJyxcbiAgZ2FwOiAndmFyKC0tZ2FwKScsXG59XG5cbmV4cG9ydCBjb25zdCBSb3cgPSBzdHlsZWQoRmxleCkoXG4gIGNzcyh7XG4gICAgZmxleERpcmVjdGlvbjogJ2NvbHVtbicsXG5cbiAgICAuLi5zaGFkb3dCb3JkZXJzKHsgdG9wOiB0cnVlLCBib3R0b206IHRydWUsIHN0cm9rZTogeC5zdHJva2UgfSksXG4gICAgJyYucm93ICsgJi5yb3cnOiB7XG4gICAgICAnOjpiZWZvcmUnOiB7IHRvcDogeC5vZmZzZXQsIGJvdHRvbTogMCB9LFxuICAgIH0sXG4gIH0pXG4pXG5leHBvcnQgY29uc3QgSGVhZCA9IHN0eWxlZChGbGV4KShcbiAgY3NzKHtcbiAgICB3aWR0aDogJzEwMCUnLFxuICAgIGZvbnRTaXplOiB4LmZvbnRTaXplLFxuICAgIGFsaWduSXRlbXM6ICdzdHJldGNoJyxcbiAgfSlcbilcbmV4cG9ydCBjb25zdCBHcmlkID0gc3R5bGVkKFRoZW1lR3JpZCkoXG4gIGNzcyh7XG4gICAgcHk6IHgucHksXG4gICAgd2lkdGg6ICcxMDAlJyxcbiAgICBncmlkR2FwOiB4LmdhcCxcbiAgfSlcbilcbmV4cG9ydCBjb25zdCBJY29uQnV0dG9uID0gc3R5bGVkKEJhc2VJY29uQnV0dG9uKShcbiAgY3NzKHtcbiAgICBtbDogeC5nYXAsXG4gICAgYWxpZ25JdGVtczogJ2NlbnRlcicsXG4gIH0pXG4pXG4iXX0= */");

var IconButton = /*#__PURE__*/_styled(IconButton$1, process.env.NODE_ENV === "production" ? {
  target: "e137hhyr0"
} : {
  target: "e137hhyr0",
  label: "IconButton"
})(css({
  ml: x$1.gap,
  alignItems: 'center'
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYmxlUm93LnN0eWxlZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxQzBCIiwiZmlsZSI6IlRhYmxlUm93LnN0eWxlZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgc2hhZG93Qm9yZGVycyB9IGZyb20gJ0Btb25vYml0cy9jb3JlJ1xuaW1wb3J0IHsgY3NzLCBGbGV4LCBHcmlkIGFzIFRoZW1lR3JpZCB9IGZyb20gJ3RoZW1lLXVpJ1xuaW1wb3J0IEJhc2VJY29uQnV0dG9uIGZyb20gJy4uL0ljb25CdXR0b24nXG5cbmNvbnN0IHggPSB7XG4gIHN0cm9rZTogJ3ZhcigtLXN0cm9rZSknLFxuICBvZmZzZXQ6ICd2YXIoLS1vZmZzZXQsIC0zMHB4KScsXG4gIGZvbnRTaXplOiAndmFyKC0tZm9udC1zaXplKScsXG4gIHB5OiAndmFyKC0tcHkpJyxcbiAgZ2FwOiAndmFyKC0tZ2FwKScsXG59XG5cbmV4cG9ydCBjb25zdCBSb3cgPSBzdHlsZWQoRmxleCkoXG4gIGNzcyh7XG4gICAgZmxleERpcmVjdGlvbjogJ2NvbHVtbicsXG5cbiAgICAuLi5zaGFkb3dCb3JkZXJzKHsgdG9wOiB0cnVlLCBib3R0b206IHRydWUsIHN0cm9rZTogeC5zdHJva2UgfSksXG4gICAgJyYucm93ICsgJi5yb3cnOiB7XG4gICAgICAnOjpiZWZvcmUnOiB7IHRvcDogeC5vZmZzZXQsIGJvdHRvbTogMCB9LFxuICAgIH0sXG4gIH0pXG4pXG5leHBvcnQgY29uc3QgSGVhZCA9IHN0eWxlZChGbGV4KShcbiAgY3NzKHtcbiAgICB3aWR0aDogJzEwMCUnLFxuICAgIGZvbnRTaXplOiB4LmZvbnRTaXplLFxuICAgIGFsaWduSXRlbXM6ICdzdHJldGNoJyxcbiAgfSlcbilcbmV4cG9ydCBjb25zdCBHcmlkID0gc3R5bGVkKFRoZW1lR3JpZCkoXG4gIGNzcyh7XG4gICAgcHk6IHgucHksXG4gICAgd2lkdGg6ICcxMDAlJyxcbiAgICBncmlkR2FwOiB4LmdhcCxcbiAgfSlcbilcbmV4cG9ydCBjb25zdCBJY29uQnV0dG9uID0gc3R5bGVkKEJhc2VJY29uQnV0dG9uKShcbiAgY3NzKHtcbiAgICBtbDogeC5nYXAsXG4gICAgYWxpZ25JdGVtczogJ2NlbnRlcicsXG4gIH0pXG4pXG4iXX0= */");

var _excluded$4 = ["content", "id", "sx"];
var KEYS$2 = {
  VARIANT: 'table.grid'
};

var Cols = function Cols(_ref) {
  var content = _ref.content,
      id = _ref.id,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement(Grid, _extends({
    sx: _extends({
      variant: KEYS$2,
      '&': {
        variant: "table.cols." + content.length
      }
    }, sx)
  }, props), content.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Flex$1, {
      sx: {
        width: '100%'
      },
      className: "cell",
      key: id + i
    }, item);
  }));
};

var Cols$1 = /*#__PURE__*/memo(Cols);
var _excluded$3 = ["icon", "active", "sx", "className"];
var KEYS$1 = {
  VARIANT: 'table.icon'
};

var Button = function Button(_ref) {
  var icon = _ref.icon,
      active = _ref.active,
      sx = _ref.sx,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  return /*#__PURE__*/React.createElement(IconButton, _extends({
    variant: icon,
    className: cls(className, {
      _active: active
    }),
    sx: _extends({
      '&': {
        variant: setVariantString(KEYS$1.VARIANT, icon)
      }
    }, sx)
  }, props), /*#__PURE__*/React.createElement(Icon, {
    icon: use[icon]
  }));
};

var use = {
  plus: Cross,
  arrow: Arrow
};
var _excluded$2 = ["children", "content", "expanded", "sx", "className"];
var TableRow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      content = _ref.content,
      expanded = _ref.expanded,
      sx = _ref.sx,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var id = useMemo(function () {
    return nanoid();
  }, []);

  var _useToggle = useToggle(true),
      trigger = _useToggle[0],
      setTrigger = _useToggle[1];

  var isExpanded = children && trigger === expanded;
  var icon = children ? 'plus' : 'arrow';
  return /*#__PURE__*/React.createElement(Row, _extends({
    ref: ref,
    className: cls(className, 'row'),
    sx: _extends({
      variant: 'table.row'
    }, sx)
  }, props), /*#__PURE__*/React.createElement(Head, {
    as: "button",
    "aria-label": content,
    "aria-expanded": isExpanded,
    onClick: function onClick() {
      return setTrigger();
    }
  }, /*#__PURE__*/React.createElement(Cols$1, {
    id: id,
    content: content
  }), /*#__PURE__*/React.createElement(Button, {
    as: "div",
    icon: icon,
    active: isExpanded
  })), children && /*#__PURE__*/React.createElement(Collapsible, {
    variant: "table",
    expanded: expanded,
    onTrigger: trigger
  }, children));
});
TableRow.defaultProps = {
  as: 'div',
  content: [],
  expanded: false
};
var x = {
  from: 'var(--from, 1)',
  to: 'var(--to, 0)',
  stroke: 'var(--stroke, 0.06em)',
  gap: 'var(--gap, 0)',
  speed: 'var(--speed, 0.45s)',
  ease: 'var(--ease, ease)'
};

var EmotionUnderlined = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "eq8wlaf0"
} : {
  target: "eq8wlaf0",
  label: "EmotionUnderlined"
})(css({
  width: 'fit-content',
  whiteSpace: 'nowrap',
  position: 'relative',
  userSelect: 'none',
  display: 'inline-flex',
  '--from': '0.9999',
  '--to': '0.0001',
  '&.-inverted': {
    '--from': '0.0001',
    '--to': '0.9999'
  },
  '.stroke': _extends({
    display: 'inline-flex',
    pointerEvents: 'none',
    bg: 'currentColor',
    width: '100%',
    height: x.stroke
  }, position('absolute', null, 0, x.gap, 0), {
    transform: "scaleX(" + x.from + ")",
    transformOrigin: 'left',
    transition: "transform " + x.speed + " " + x.ease
  }),
  '&._hover,&._active': {
    '.stroke': {
      transform: "scaleX(" + x.to + ")"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVuZGVybGluZWQuc3R5bGVkLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFpQyIsImZpbGUiOiJVbmRlcmxpbmVkLnN0eWxlZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgcG9zaXRpb24gfSBmcm9tICdwb2xpc2hlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ3RoZW1lLXVpJ1xuXG5jb25zdCB4ID0ge1xuICBmcm9tOiAndmFyKC0tZnJvbSwgMSknLFxuICB0bzogJ3ZhcigtLXRvLCAwKScsXG4gIHN0cm9rZTogJ3ZhcigtLXN0cm9rZSwgMC4wNmVtKScsXG4gIGdhcDogJ3ZhcigtLWdhcCwgMCknLFxuICBzcGVlZDogJ3ZhcigtLXNwZWVkLCAwLjQ1cyknLFxuICBlYXNlOiAndmFyKC0tZWFzZSwgZWFzZSknLFxufVxuXG5leHBvcnQgY29uc3QgRW1vdGlvblVuZGVybGluZWQgPSBzdHlsZWQuc3BhbihcbiAgY3NzKHtcbiAgICB3aWR0aDogJ2ZpdC1jb250ZW50JyxcbiAgICB3aGl0ZVNwYWNlOiAnbm93cmFwJyxcbiAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcblxuICAgIHVzZXJTZWxlY3Q6ICdub25lJyxcbiAgICBkaXNwbGF5OiAnaW5saW5lLWZsZXgnLFxuXG4gICAgJy0tZnJvbSc6ICcwLjk5OTknLFxuICAgICctLXRvJzogJzAuMDAwMScsXG5cbiAgICAnJi4taW52ZXJ0ZWQnOiB7XG4gICAgICAnLS1mcm9tJzogJzAuMDAwMScsXG4gICAgICAnLS10byc6ICcwLjk5OTknLFxuICAgIH0sXG5cbiAgICAnLnN0cm9rZSc6IHtcbiAgICAgIGRpc3BsYXk6ICdpbmxpbmUtZmxleCcsXG4gICAgICBwb2ludGVyRXZlbnRzOiAnbm9uZScsXG5cbiAgICAgIGJnOiAnY3VycmVudENvbG9yJyxcblxuICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgIGhlaWdodDogeC5zdHJva2UsXG4gICAgICAuLi5wb3NpdGlvbignYWJzb2x1dGUnLCBudWxsLCAwLCB4LmdhcCwgMCksXG5cbiAgICAgIHRyYW5zZm9ybTogYHNjYWxlWCgke3guZnJvbX0pYCxcbiAgICAgIHRyYW5zZm9ybU9yaWdpbjogJ2xlZnQnLFxuICAgICAgdHJhbnNpdGlvbjogYHRyYW5zZm9ybSAke3guc3BlZWR9ICR7eC5lYXNlfWAsXG4gICAgfSxcblxuICAgICcmLl9ob3ZlciwmLl9hY3RpdmUnOiB7XG4gICAgICAnLnN0cm9rZSc6IHtcbiAgICAgICAgdHJhbnNmb3JtOiBgc2NhbGVYKCR7eC50b30pYCxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSlcbilcbiJdfQ== */");

var _span;

var _excluded$1 = ["hover", "inverted", "variant", "sx", "className"];
var KEYS = {
  VARIANT: 'link'
};
var Underlined = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var hover = _ref.hover,
      inverted = _ref.inverted,
      variant = _ref.variant,
      sx = _ref.sx,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return jsx(EmotionUnderlined, _extends({
    ref: ref,
    sx: _extends({
      variant: setVariantString(KEYS.VARIANT, variant)
    }, sx),
    className: cls(className, hover, {
      '-inverted': inverted
    })
  }, linkA11yProps(props)), props.children, _span || (_span = jsx("span", {
    className: "stroke",
    "aria-hidden": "true"
  })));
});
Underlined.propTypes = _extends({
  inverted: PropTypes.bool
}, props.themeUi);
Underlined.defaultProps = {
  as: 'span',
  inverted: false,
  variant: 'underlined'
};
var Underlined$1 = withHover(Underlined, {
  mouse: true
});
var _excluded = ["data", "sx"];

var Paragraphs = function Paragraphs(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var id = useMemo(function () {
    return nanoid();
  }, []);
  return data.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Text, _extends({
      key: id + i,
      children: item,
      sx: sx
    }, props));
  });
};

export { Box, Burger$1 as Burger, Button$2 as Button, Collapsible, ColorSwitch, Container$1 as Container, Emoji, Flex, Heading, Icon, IconButton$1 as IconButton, Markup, Marquee, Paragraphs, Scroller, Section, Sizes, SkewLink$1 as SkewLink, TableRow, Text, Underlined$1 as Underlined };